import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Observable } from 'rxjs';
import { BadgeModule } from 'primeng/badge';
import { Nillable } from '@web/utils';

@Component({
  selector: 'app-counter-badge',
  imports: [AsyncPipe, BadgeModule],
  templateUrl: './counter-badge.component.html',
  styleUrl: './counter-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CounterBadgeComponent {
  public readonly counter$ = input<Nillable<Observable<number>>>(null);
}
